import { render } from "./MdChips.vue?vue&type=template&id=6b756acc"
import script from "./MdChips.vue?vue&type=script&lang=js"
export * from "./MdChips.vue?vue&type=script&lang=js"

import "./MdChips.vue?vue&type=style&index=0&id=6b756acc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__